import { render, staticRenderFns } from "./HgLogo.vue?vue&type=template&id=3bd720b2&"
import script from "./HgLogo.vue?vue&type=script&lang=js&"
export * from "./HgLogo.vue?vue&type=script&lang=js&"
import style0 from "./HgLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports